
/**
 * deleteItensServicoEmpreendimentoUseCaseUseCase
 */
import { IDeleteItensServicoEmpreendimentoUseCase } from "../../../presentation/useCases/delete/delete_itens_servico_empreendimento_use_case";
import { IIncorporacaoRepository } from "../../repositories/incorporacao_repositories";

export class DeleteItensServicoEmpreendimentoUseCase implements IDeleteItensServicoEmpreendimentoUseCase {
  constructor(private readonly repository: IIncorporacaoRepository) { }

  async execute(
    idChecklistServicoEmpreendimento: number,
    idsItemServicoEmpreendimento: number[]
  ): Promise<void> {
    return this.repository.deleteItensServicoEmpreendimento(
      idChecklistServicoEmpreendimento,
      idsItemServicoEmpreendimento
    );


  }
}
